import { render, staticRenderFns } from "./plate.vue?vue&type=template&id=8808f664&scoped=true&"
import script from "./plate.vue?vue&type=script&lang=js&"
export * from "./plate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808f664",
  null
  
)

export default component.exports